export const DetectBrand = {
  methods: {
    isBranded: function() {
      var brandBuildVar = "true";
      if (brandBuildVar != "true" && brandBuildVar != "false") {
        brandBuildVar = "true";
      }
      var isBranded =
        process.env.NODE_ENV === "production" ? brandBuildVar : "true";
      return isBranded === "true" ? true : false;
    }
  }
};
